import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=24d2a104&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=24d2a104&prod&scoped=true&lang=css"
import style1 from "./ContactDetails.vue?vue&type=style&index=1&id=24d2a104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2a104",
  null
  
)

export default component.exports